import React, { useCallback } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import WarningIcon from '@atlaskit/icon/glyph/warning';
import { Flex } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import {
	DeactivationText,
	DeactivationWarningStyled,
	RemoveUsersLink,
} from '../styled/StyledModal';
import { useUserInfo } from '../store/userInfoStore';
import { useButtonEventHandler } from '../hooks/analytics-handlers/useButtonEventHandler';
import { useExperimentInfo } from '../store/experimentInfoStore';
import { analytics } from '../experimentConstants';

const i18n = defineMessages({
	overFreeUserLimit: {
		id: 'end-of-trial-payment-modals.standard.over-free-user-limit',
		defaultMessage:
			'To prevent site deactivation on {endDate, date, long}, add payment details or <a>remove users</a> and downgrade.',
		description: 'Guest access subtitle',
	},
});

export const DeactivationWarning = () => {
	const { trialEndDate } = useUserInfo();
	const { eventHandler } = useButtonEventHandler();
	const { cohort } = useExperimentInfo();

	const handleClick = useCallback(() => {
		eventHandler({
			actionSubjectId: 'trialActionComponent',
			userAction: 'removeUser',
			type: 'info',
			experiment: analytics.SOURCE,
			cohort,
		});
	}, [cohort, eventHandler]);

	return (
		<DeactivationWarningStyled>
			<Flex>
				<WarningIcon label="warning" primaryColor={token('color.icon.warning', '#e56910')} />
				<DeactivationText>
					<FormattedMessage
						{...i18n.overFreeUserLimit}
						values={{
							// I prefer trialEndDate as string but that's banned now I guess
							endDate: new Date(trialEndDate || ''),
							// eslint-disable-next-line react/no-unstable-nested-components
							a: (chunks: React.ReactNode[]) => (
								<RemoveUsersLink
									href={`${window.location.origin}/admin`}
									onClick={handleClick}
									target="_blank"
								>
									{chunks}
								</RemoveUsersLink>
							),
						}}
					/>
				</DeactivationText>
			</Flex>
		</DeactivationWarningStyled>
	);
};
